import React from "react";
import styles from "./confirmationPopup.module.css";
import { Submit } from "../../../../components/button/buttons";
import { DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";


// export const DEMAND_ACTIONS1 = {
//   INITIATE_FISIBILITY:'initiate-feasibiity',
//   CPMPLETE_FEASIBILITY:'complete-feasibiity',
//   INITIATE_FLOOR_PRICING:'initiate-floor-pricing',
//   INITIATE_MARGIN:'initiate-margin',
//   GENERATE_QUOTATION:'generate-quotation',
//   REVIEW_QUOTATION:'review-quotation',
//   COMPLETE_DRAFT_ORDERFORM:'complete-draft-orderform',
//   SAVE_ORDERFORM:'save-orderform',
//   SUBMIT_SIGNED_ORDERFORM:"submit-signed-orderform",
//   INITIATE_LEGAL_CONTRACT:"intiate-legal-contract",
//   INITIATE_PROVISIONING:'initiate-provisioning',
//   COMPLETE_PROVISIONING:'complete-provisioning',
//   INITIATE_BILLING:'initiate-billing',
//   COMPLETE_BILLING:'complete-billing',
//   COMPLETE_DEMAND:'complete-demand',
//   UPLOAD_LEGAL_CONTRACT:"upload-legal-contract"
// }



const getMessage=(action)=>{
  console.log("action",action)
  switch(action){
    case DEMAND_ACTIONS.INITIATE_FISIBILITY:
      return {
        title:"Confirm Feasibility Assessment Initiation",
        description:`This action will move the demand to the 'Feasibility Assessment' stage and notify the concerned Vodafone teams to begin evaluation.
        \nThis action is irreversible, and the demand cannot be moved back to the previous stage.
        \nAre you sure you want to proceed?`,
        submitBtn:"Initiate",
        cancelBtn:"Cancel"
      }
    case DEMAND_ACTIONS.INITIATE_FLOOR_PRICING:
      return {
        title:"Confirm Floor Pricing Initiation",
        description:`This action will move the demand to the 'Floor Pricing' stage and notify the concerned Vodafone  teams to begin baseline pricing preparation.
        \nThis action is irreversible, and the demand cannot be moved back to the previous stage.        .
        \nAre you sure you want to proceed?`,
        submitBtn:"Initiate",
        cancelBtn:"Cancel"
      }
    default:
      return {
        title:"Confirm Action",
        description:`Do you really want to Proceed?.`,
        submitBtn:"Submit",
        cancelBtn:"Cancel",
      }

  }

}

const ConfirmationModal = ({ onClose, onSubmit, isloading,action }) => {

  const message = getMessage(action)
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.headertxt}>{message.title}</div>
        <div className={styles.group}>
          <div className={styles.message}>{message.description.split('\n').map(item=><div>{item}</div>)}</div>
        </div>
        <div className={styles.group}>
          <div onClick={onClose} className={styles.cancel}>{message.cancelBtn}</div>
          {/* <div onClick={onSubmit} className={styles.submit}>Submit</div> */}
           <Submit
                onClick={() => onSubmit()}
                style={styles.headlesend}
                loaderstyle={styles.loaderstyle}
                isSubmitting={isloading}
                title={message.submitBtn}
            />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;